import { CancelTokenSource } from 'axios';
import {
  CreateRoadmapDTO,
  IApplicationRoadmap,
  IEntityAggrByDate,
  IRoadmap,
  RoadmapView,
  UpdateRoadmapDTO,
} from '../types';
import { ApiRepository } from './main repository/api.repository';
import { TimelineDTO } from '../types/timeline.type';

export namespace RoadmapService {
  export const getRoadmapsById = async (
    cancelTokenSource: CancelTokenSource,
    roadmapIds?: number[],
    withDeleted = false
  ): Promise<RoadmapView[]> => {
    return ApiRepository.Core().get(
      `${window.globalConfiguration.api.base}/v1/roadmaps/many`,
      { ids: roadmapIds?.join(','), withDeleted },
      { cancelToken: cancelTokenSource.token }
    );
  };

  export const getRoadmapById = async (
    cancelTokenSource: CancelTokenSource,
    roadmapId: number
  ): Promise<RoadmapView> => {
    return ApiRepository.Core().get(`${window.globalConfiguration.api.base}/v1/roadmaps/${roadmapId}`, undefined, {
      cancelToken: cancelTokenSource.token,
    });
  };

  export const updateRoadmap = async (
    cancelTokenSource: CancelTokenSource,
    roadmapId: number,
    updateRoadmapDTO: UpdateRoadmapDTO
  ): Promise<IRoadmap> => {
    return ApiRepository.Core().put(
      `${window.globalConfiguration.api.base}/v1/roadmaps/${roadmapId}`,
      updateRoadmapDTO,
      {},
      { cancelToken: cancelTokenSource.token }
    );
  };

  export const createRoadmap = async (
    cancelTokenSource: CancelTokenSource,
    createRoadmapDTO: CreateRoadmapDTO
  ): Promise<IRoadmap> => {
    return ApiRepository.Core().post(
      `${window.globalConfiguration.api.base}/v1/roadmaps`,
      createRoadmapDTO,
      {},
      { cancelToken: cancelTokenSource.token }
    );
  };

  export const deleteRoadmap = async (roadmapId: number): Promise<IRoadmap> => {
    return ApiRepository.Core().delete(`${window.globalConfiguration.api.base}/v1/roadmaps/${roadmapId}`);
  };

  export const getTimeline = async ({
    roadmapId,
    cancelTokenSource,
  }: {
    roadmapId: number;
    cancelTokenSource: CancelTokenSource;
  }): Promise<TimelineDTO> => {
    return ApiRepository.Core().get(
      `${window.globalConfiguration.api.base}/v1/roadmaps/${roadmapId}/timeline`,
      undefined,
      {
        cancelToken: cancelTokenSource.token,
      }
    );
  };
}
